import { useNumberSerialiser } from "hooks/serialisers/numbers";
import { useCallback } from "react";
import type { RadioReceiver } from "src/store/api/generatedApi";

// The channel dropdown and the chips on transcript lines have to agree, or one
// channel reads as two.
export const useChannelName = () => {
  const { format } = useNumberSerialiser({ decimalPlaces: 3 });

  return useCallback(
    (receiver: RadioReceiver): string =>
      receiver.label ??
      (receiver.frequency_hz != null
        ? `${format(receiver.frequency_hz / 1_000_000)} MHz`
        : receiver.receiver_key),
    [format]
  );
};
